export const ATTENDING = 'attending'
export const NOT_ATTENDING = 'not attending'
export const PENDING = 'pending'
export const IN_THE_LOOP = 'none'